const createSchema = (state) => {
  const mealCharges = state.mealCharges || {
    minimum: 16.28, // Fallback values
    maximum: 68,
  };

  return {
    name: "Provision of Meals and Transportation",
    prefix: "E/F",
    code: "E/F",
    sections: [
      {
        divider: "hide",
        name: "",
        fields: [
          {
            code: "E.1",
            machine_name: "eta_790a_e1_meals_info",
            widget: "text_area",
            label:
              "<span>Describe how the employer will provide each worker with three meals per day or furnish free and convenient cooking and kitchen facilities.<br></br><i>(Please begin response on this form and use Addendum C if additional space is needed.)</i></span>",
            validate: [
              "required",
              {
                minLength: 5,
                message:
                  "How the employer will provide each worker with 3 meals must contain at least 5 characters.",
              },
            ],
            tooltip:
              "Describe how the employer will provide each worker with three (3) meals a day or furnish free and convenient cooking and kitchen facilities so that workers can prepare their own meals.  Where the employer provides facilities for workers to prepare their own meals, please explain how the workers will have access to stores where they can purchase groceries and describe the facilities and space for food preparation, as well as the necessary equipment, appliances (including refrigeration), cooking accessories, and dishwashing facilities (e.g., adequate sinks with hot and cold water under pressure) that are in working condition and will be used by workers to sufficiently prepare three (3) meals a day.  If the employer has an agreement with a third-party that will prepare the meals for the employer's workers, identify the vendor and explain the employer's arrangement with the vendor with sufficient detail to apprise workers how, when, and where the workers will obtain the meals from the vendor and that the employer will pay the vendor directly for the meals provided. <br/><strong>Important Note:</strong>  Providing access to third-party vendors and requiring workers to purchase meals from the third-party vendor does not constitute compliance with the requirement to provide meals or cooking and kitchen facilities, even if the employer provides a meal stipend.",
            placeholder: "",
            width: 8,
            rows: 10,
            inputLimit: 1000,
            is_required: true,
          },
        ],
      },
      {
        machine_name: "_add_addendum_c_meal_provision",
        coloring: "blue",
        isModal: true,
        master_fieldArray: "eta_790a_addendum_c",
        listType: "inline",
        sectionHeader: "Material Terms and Conditions - Meal Provision",
        openModalHeader: "Add Addendum C",
        modalHeader: "Add Material Terms and Conditions of the Job Offer",
        modalFields: [
          {
            machine_name: "section_number",
            label:
              "Section/Item Number and Category of Material Term or Condition",
            widget: "select",
            selection: [
              "Job Duties",
              "Pay Deductions",
              "Job Requirements",
              "Meal Provision",
              "Daily Transportation",
              "Inbound/Outbound Transportation",
              "Referral and Hiring Instructions",
            ],
            disabled: true,
            initialValue: "Meal Provision",
            validate: ["required"],
            tooltip: "Meal Provision.",
          },
          {
            machine_name: "section_name",
            label: "Summary of Material Term Condition",
            widget: "text",
            validate: [
              {
                minLength: 5,
                message:
                  "Summary of Material Terms Conditions must contain at least 5 characters",
              },
            ],
            maxLength: 150,
          },
          {
            machine_name: "section_details",
            label: "Details of Material Term or Condition",
            widget: "text_area",
            rows: "8",
            inputLimit: 3500,
            validate: [
              "required",
              {
                minLength: 5,
                message:
                  "Details of Material Term or Condition must contain at least 5 characters",
              },
            ],
            // tooltip: "tooltip"
          },
        ],
      },

      {
        name: "",
        fields: [
          {
            isGroup: {
              label: "The employer:",
              machine_name: "eta_790a_e2b_will_charge",
              tooltip: `Select the option designating whether the employer will charge workers for the provision of meals. If the employer will
                provide free and convenient cooking and kitchen facilities or will provide meals at no charge, mark the "will not charge"
              box. If the employer will provide meals, or will provide free and convenient cooking and kitchen facilities but wishes to
              disclose a meal charge, for example, in the event the kitchen facilities become unavailable, and intends to charge workers
              for the provision of meals, the daily charge per worker must be entered in currency format (e.g., $9.99).`,
              coloring: "none",
              disabled: true,
              required: true,
              Other_machine_name: "eta_790a_e2a_will_not_charge",
              validate: ["required"],
              fields: [
                {
                  widget: "radio",
                  choice: "<b>WILL NOT</b> charge workers for meals.",
                  value: "NO",
                  validate: ["required"],
                },
                {
                  widget: "radio",
                  choice:
                    "<b>WILL</b> charge each worker for meals at _ per day, if meals are provided.",
                  value: "YES",
                  validate: ["required"],
                },
              ],
            },
          },
          {
            machine_name: "eta_790a_e2c_meal_charge",
            widget: "wage",
            label: "Meal Charge",
            maxLength: 4,
            validate: [
              "required",
              {
                minValue: 1,
                message:
                  "The amount of the charge per day if meals are provided, must be greater than $0.00",
              },
            ],
            isVisible: {
              when: "eta_790a_e2b_will_charge",
              is: "YES",
            },
            warning: {
              text: "The charge amount entered appears to exceed than the current standard meal charge per day per worker. In accordance with 20 CFR 655.173, the employer may file a petition with the OFLC Certifying Officer to charge more than the standard amount for meal charges. Please be prepared to submit, at the time of filing your H-2A application, documentation justifying the meal charge. Documentation submitted must include the cost of goods and services directly related to the preparation and serving of meals, the number of workers fed, the number of meals served and the number of days meals were provided. The cost of the following items may be included: Food; kitchen supplies other than food, such as lunch bags and soap; labor costs that have a direct relation to food service operations, such as wages of cooks and dining hall supervisors; fuel, water, electricity, and other utilities used for the food service operation; and other costs directly related to the food service operation. Charges for transportation, depreciation, overhead and similar charges may not be included. Receipts and other cost records for a representative pay period must be retained and must be available for inspection by the CO for a period of 1 year.",
              isVisible: {
                when: "eta_790a_e2c_meal_charge",
                is: "56",
                operator: ">=",
              },
            },
          },
        ],
      },
      {
        divider: "hide",
        name: "",
        fields: [
          {
            code: "F.1",
            machine_name: "eta_790a_f1_daily_transport",
            widget: "text_area",
            label:
              "<span>Describe the terms and arrangement for daily transportation the employer will provide to workers. <br></br><i>(Please begin response on this form and use Addendum C if additional space is needed.)</i></span>",
            validate: [
              "required",
              {
                minLength: 5,
                message:
                  "Terms and arrangement for daily transportation must contain at least 5 characters.",
              },
            ],
            tooltip: `Describe how the employer will provide workers daily transportation to the place(s) of employment. At a minimum,
            describe the arrangements for transporting workers, at no cost to workers, from employer-provided or secured housing
            and, if applicable, centralized pick-up points to the places of employment at the beginning of each workday and back at
              the end of each workday. Describe the employer's daily transportation plan with sufficient detail to apprise workers of the
            mode(s) of transportation (e.g., vans, buses) that will be used each day, if known, as well as the daily transportation
            schedule. Identify the number of vehicles to be used and type of vehicle and seating capacity for each vehicle. State whether the vehicles to be used will be provided by the fixed-site grower(s), are authorized for use under a valid Farm
            Labor Contractor Certificate of Registration, or belong to a common carrier, identifying the common carrier by name. In
            addition, identify whether the daily transportation at no cost to workers is available to workers who do not reside in
            employer-provided housing. If additional space is needed, use the Form ETA-790A, Addendum C.`,
            placeholder: "",
            width: 8,
            rows: 10,
            inputLimit: 500,
            is_required: true,
          },
        ],
      },
      {
        machine_name: "_add_addendum_c_daily_transportation",
        coloring: "blue",
        isModal: true,
        master_fieldArray: "eta_790a_addendum_c",
        listType: "inline",
        sectionHeader: "Material Terms and Conditions - Daily Transportation",
        openModalHeader: "Add Addendum C",
        modalHeader: "Add Material Terms and Conditions of the Job Offer",
        modalFields: [
          {
            machine_name: "section_number",
            label:
              "Section/Item Number and Category of Material Term or Condition",
            widget: "select",
            selection: [
              "Job Duties",
              "Pay Deductions",
              "Job Requirements",
              "Meal Provision",
              "Daily Transportation",
              "Inbound/Outbound Transportation",
              "Referral and Hiring Instructions",
            ],
            disabled: true,
            initialValue: "Daily Transportation",
            validate: ["required"],
            tooltip:
              "Category should be Materials Terms and Conditions - Daily Transportation.",
          },
          {
            machine_name: "section_name",
            label: "Summary of Material Term Condition",
            widget: "text",
            validate: [
              {
                minLength: 5,
                message:
                  "Summary of Material Terms Conditions must contain at least 5 characters",
              },
            ],
            maxLength: 150,
          },
          {
            machine_name: "section_details",
            label: "Details of Material Term or Condition",
            widget: "text_area",
            rows: "8",
            inputLimit: 3500,
            validate: [
              "required",
              {
                minLength: 5,
                message:
                  "Details of Material Term or Condition must contain at least 5 characters",
              },
            ],
            // tooltip: "tooltip"
          },
        ],
      },
      {
        divider: "hide",
        name: "",
        fields: [
          {
            code: "F.2",
            machine_name: "eta_790a_f2_transport_to_from",
            widget: "text_area",
            label:
              "<span>Describe the terms and arrangements for providing workers with transportation (a) to the place of employment (i.e., inbound) and (b) from the place of employment (i.e., outbound). <br></br><i>(Please begin response on this form and use Addendum C if additional space is needed.)</i></span>",
            validate: [
              "required",
              {
                minLength: 5,
                message:
                  "Terms and arrangements for transportation to and from work must contain at least 5 characters.",
              },
            ],
            tooltip: `Describe how the employer will provide workers with transportation (a) to the place of employment from the place from
            which the worker has come to work for the employer (i.e., inbound) and (b) from the place of employment to the place
            from which the worker departed (i.e., outbound). At a minimum, state whether such transportation, and related daily
            subsistence, will be provided by the employer or paid by the employer to the worker for reasonable costs incurred (e.g.,
            advance payment or reimbursement) and identify the modes of transportation, if known. For example, the employer may
            state that it will provide or pay for charter bus services or other modes of transportation to groups of workers, or permit
            workers to select any means of transportation they choose and reimburse workers at no less than the most economical
            and reasonable common carrier transportation charges for the distances involved. If additional space is needed, use the
            Form ETA-790A, Addendum C.`,
            placeholder: "",
            width: 8,
            rows: 10,
            inputLimit: 500,
            is_required: true,
          },
        ],
      },
      {
        machine_name: "_add_addendum_c_inbound_outbount_transportation",
        coloring: "blue",
        isModal: true,
        master_fieldArray: "eta_790a_addendum_c",
        listType: "inline",
        sectionHeader:
          "Materials Terms and Conditions - Inbound/Outbound Transportation",
        openModalHeader: "Add Addendum C",
        modalHeader: "Add Material Terms and Conditions of the Job Offer",
        modalFields: [
          {
            machine_name: "section_number",
            label:
              "Section/Item Number and Category of Material Term or Condition",
            widget: "select",
            selection: [
              "Job Duties",
              "Pay Deductions",
              "Job Requirements",
              "Meal Provision",
              "Daily Transportation",
              "Inbound/Outbound Transportation",
              "Referral and Hiring Instructions",
            ],
            disabled: true,
            initialValue: "Inbound/Outbound Transportation",
            validate: ["required"],
            tooltip:
              "Category should be Materials Terms and Conditions - Inbound/Outbound Transportation.",
          },
          {
            machine_name: "section_name",
            label: "Summary of Material Term Condition",
            widget: "text",
            validate: [
              {
                minLength: 5,
                message:
                  "Summary of Material Terms Conditions must contain at least 5 characters",
              },
            ],
            maxLength: 150,
          },
          {
            machine_name: "section_details",
            label: "Details of Material Term or Condition",
            widget: "text_area",
            rows: "8",
            inputLimit: 3500,
            validate: [
              "required",
              {
                minLength: 5,
                message:
                  "Details of Material Term or Condition must contain at least 5 characters",
              },
            ],
            // tooltip: "tooltip"
          },
        ],
      },
      {
        name: "",
        fields: [
          {
            isGroup: {
              code: "F.3",
              fieldLevelErrors: true,
              machine_name: "_meal_reimbursement",
              tooltip:
                "Enter the amounts per day that the employer will pay for or reimburse daily meals for each worker.",
              label:
                "During the travel described in Item 2, the employer will pay for or reimburse daily meals by providing each worker",
              fields: [
                {
                  machine_name: "eta_790a_f3a_no_less_than",
                  widget: "wage",
                  label: "No less than",
                  labelPostfix: "per day",
                  validate: [
                    "required",
                    {
                      minValue: mealCharges.minimum,
                      message:
                        "Employer will pay/reimburse daily meals no less than value must be greater than current OFLC Public Amount.",
                    },
                    {
                      maxValue: mealCharges.maximum,
                      message:
                        "Employer will pay/reimburse daily meals no less than value must be less than current OFLC Public Amount.",
                    },
                  ],
                  maxLength: 4, // accounts for the "$" and decimals
                  tooltip:
                    "Enter the minimum daily subsistence amount per day in currency format (e.g., $99.99).",
                },
                {
                  machine_name: "eta_790a_f3b_no_more_than",
                  widget: "wage",
                  label: "No more than",
                  labelPostfix: "per day with receipts",
                  validate: [
                    "required",
                    {
                      minValue: mealCharges.minimum,
                      message:
                        "Employer will pay/reimburse daily meals no more than value must be greater than current OFLC Public Amount.",
                    },
                    {
                      maxValue: mealCharges.maximum,
                      message:
                        "Employer will pay/reimburse daily meals no more than value must be less than current OFLC Public Amount.",
                    },
                  ],
                  maxLength: 4, // accounts for the "$" and decimals
                  tooltip:
                    "Enter the maximum daily subsistence amount per day with receipts in currency format (e.g., $99.99).",
                  info: {
                    text: `Employer daily meal reimbursement must be no less than $${mealCharges.minimum} and no more than $${mealCharges.maximum}.00.`,
                    coloring: "grey",
                    divider: false,
                    css: {
                      marginTop: 20,
                      marginBottom: 10,
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    ],
  };
};

// Create default version with fallback values
const defaultSchema = createSchema({});

export { createSchema };
export default defaultSchema;
